import { useState, useRef, useEffect } from 'react';

const PracticeMultiSelect = ({ value, onChange, options,isInvalid  }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Convert value prop to array
  const getSelectedValues = () => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') return value.split(',').filter(Boolean);
    return [];
  };

  const [selectedValues, setSelectedValues] = useState(getSelectedValues());

  // Sync internal selectedValues when value prop changes
  useEffect(() => {
    setSelectedValues(getSelectedValues());
  }, [value]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleOption = (option) => {
    const isSelected = selectedValues.includes(option);
    const newSelected = isSelected
      ? selectedValues.filter(v => v !== option)
      : [...selectedValues, option];

    setSelectedValues(newSelected);
    onChange(newSelected.join(','));
  };

  const displayValue = selectedValues.length > 0 
    ? selectedValues.join(', ') 
    : "Select domains";

  return (
    <div className="position-relative" style={{width: '250px'}} ref={dropdownRef}>
      {/* Selected display */}
      <div 
        className={`form-select hive-form-select ${isInvalid ? 'is-invalid' : ''}`}
        aria-label="Default select example2"
        onClick={() => setIsOpen(!isOpen)}
        style={{ cursor: 'pointer', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {displayValue}
      </div>

      {/* Dropdown options */}
      {isOpen && (
        <div className="dropdown-menu show w-100 border border-light bg-white rounded-3 p-2 shadow"style={{ maxHeight: '250px', overflowY: 'auto' }}>
          {options.map((option) => (
            <div 
              key={option}
              className={`dropdown-item ${selectedValues.includes(option) ? 'active' : ''}`}
              onClick={() => toggleOption(option)}
              style={{ cursor: 'pointer' }}
            >
              <input 
                type="checkbox" 
                checked={selectedValues.includes(option)}
                readOnly
                className="me-2"
              />
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PracticeMultiSelect;